import { isReviewedVideo } from './videoWorkflow';

export function getOrganizationMetrics({
  members = [],
  lessons = [],
  videos = [],
  templates = [],
} = {}) {
  const instructorCount = (members || []).filter((member) =>
    ['organization_owner', 'organization_admin', 'instructor'].includes(member.orgRole || member.role)
  ).length;
  const studentCount = (members || []).filter(
    (member) => (member.orgRole || member.role) === 'student'
  ).length;
  const completedReviews = (videos || []).filter(isReviewedVideo).length;
  const premiumDrills = (templates || []).filter(
    (template) => template.accessTier === 'premium' || Boolean(template.contentPackId)
  ).length;

  return {
    memberCount: (members || []).length,
    instructorCount,
    studentCount,
    lessonCount: (lessons || []).length,
    videoCount: (videos || []).length,
    completedReviews,
    drillCount: (templates || []).length,
    premiumDrillCount: premiumDrills,
  };
}

export function getInstructorMetrics({
  instructorId = '',
  lessons = [],
  videos = [],
} = {}) {
  return {
    assignedLessonCount: (lessons || []).filter(
      (lesson) =>
        lesson.assignedInstructorId === instructorId || lesson.instructorId === instructorId
    ).length,
    assignedVideoCount: (videos || []).filter(
      (video) =>
        video.assignedInstructorId === instructorId || video.assignedTo === instructorId
    ).length,
  };
}

export function getPlatformMetrics({
  organizations = [],
  members = [],
  lessons = [],
  videos = [],
  templates = [],
  contentPacks = [],
  entitlements = [],
} = {}) {
  return {
    organizationCount: (organizations || []).length,
    memberCount: (members || []).length,
    lessonCount: (lessons || []).length,
    videoCount: (videos || []).length,
    completedReviewCount: (videos || []).filter(isReviewedVideo).length,
    drillCount: (templates || []).length,
    premiumDrillCount: (templates || []).filter(
      (template) => template.accessTier === 'premium' || Boolean(template.contentPackId)
    ).length,
    contentPackCount: (contentPacks || []).length,
    entitlementCount: (entitlements || []).length,
  };
}
